import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { BlankPageQuickActionsComponentProps } from '../src/BlankPageQuickActions.tsx';

export const BlankPageQuickActions: LoadableType<BlankPageQuickActionsComponentProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-BlankPageQuickActions" */ '../src/BlankPageQuickActions.tsx'
				)
			).BlankPageQuickActions,
	});
